export const CARD_PROVIDER_IDS = {
  RAIN: "4",
  NS: "6",
} as const

export const PIN_VISIBLE_CARD_PROVIDER_IDS = [CARD_PROVIDER_IDS.RAIN, CARD_PROVIDER_IDS.NS] as const

const normalizeProviderId = (providerId?: string | number | null) => String(providerId ?? "")

export const isRainProvider = (providerId?: string | number | null) => normalizeProviderId(providerId) === CARD_PROVIDER_IDS.RAIN

export const isPinVisibleProvider = (providerId?: string | number | null) =>
  PIN_VISIBLE_CARD_PROVIDER_IDS.includes(normalizeProviderId(providerId) as (typeof PIN_VISIBLE_CARD_PROVIDER_IDS)[number])
